import React from 'react';

// import { useMediaQuery } from 'react-responsive';

// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from '../Tooltip';

import infoIcon from '../../assets/images/infoIcon.svg';

import classes from './styles.module.scss';

export default function InfoIcon({ text, width }) {
  // const isZoomedOut = useMediaQuery({ query: '(max-width: 1366px)' });

  return (
    <Tooltip width={width || 200} position="left" text={text}>
      <div className={classes.InfoIcon}>
        <img src={infoIcon} alt="Info" />
      </div>
    </Tooltip>
  );
}
